/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disp_Board_Group_HintInputs */

const en_disp_board_group_hint = /** @type {(inputs: Disp_Board_Group_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Columns come from single values: status, priority, type, assignee, milestone or a single-select Field.`)
};

const de_disp_board_group_hint = /** @type {(inputs: Disp_Board_Group_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spalten entstehen aus Einzelwerten: Status, Priorität, Typ, Zuständig, Meilenstein oder ein Feld mit Einfachauswahl.`)
};

/**
* | output |
* | --- |
* | "Columns come from single values: status, priority, type, assignee, milestone or a single-select Field." |
*
* @param {Disp_Board_Group_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const disp_board_group_hint = /** @type {((inputs?: Disp_Board_Group_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disp_Board_Group_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_disp_board_group_hint(inputs)
	return en_disp_board_group_hint(inputs)
});